[
  {
    "title": "WHAT MAKES US FUNDAMENTALLY DIFFERENT FROM OTHER NETWORKS?",
    "hasDownload": false,
    "contentTop": "Unlike traditional ad networks that focus primarily on reach or intent signals, our network connects advertisers with travelers during highly personal, curated, and trusted moments throughout their journey. This creates environments where advertising feels like value rather than interruption.",
    "contentBottom": ""
  },
  {
    "title": "HOW DOES ADVERTISING ALONGSIDE TRAVEL MOMENTS CREATE VALUE?",
    "hasDownload": false,
    "contentTop": "Ads alongside travel moments reach consumers when they are highly focused, actively planning, and open to inspiration. These moments combine trust and context, making brand messages feel more relevant than in passive browsing environments. As a result, advertisers can influence decisions more meaningfully, not just capture attention.",
    "contentBottom": ""
  },
  {
    "title": "WHAT MAKES MARRIOTT MEDIA ENVIRONMENTS UNIQUELY TRUSTED BY CONSUMERS?",
    "hasDownload": false,
    "contentTop": "Our environments are rooted in the trusted relationship travelers have with our brands. From booking to stay, our platforms are designed to enhance the travel experience. Advertising served within this ecosystem inherits that halo of trust and reliability.",
    "contentBottom": ""
  },
  {
    "title": "WHAT TYPES OF OUTCOMES IS MARRIOTT MEDIA BEST SUITED TO DRIVE?",
    "hasDownload": false,
    "contentTop": "We drive full-funnel outcomes, from upper-funnel brand awareness during the inspiration phase, to mid-funnel consideration during planning, down to lower-funnel conversions using targeted, intent-based strategies that capture travelers ready to act.",
    "contentBottom": ""
  },
  {
    "title": "WHAT TYPES OF BRANDS SEE THE STRONGEST RESULTS WITH MARRIOTT MEDIA?",
    "hasDownload": false,
    "contentTop": "Brands across all categories—from luxury goods and automotive to financial services and tech—see strong results when their messaging aligns with the affluent, highly-engaged, and global audience that our ecosystem uniquely provides.",
    "contentBottom": ""
  }
]
